<fe-header style="z-index: 1000"></fe-header>
<main>
    <section class="about__us__top position-relative text-center">
        <img
            class="mw-100"
            [src]="'images/atencionclientebaner.jpg' | cdn"
            alt="About Alamo"
        />
        <h2
            class="about__us__top__text position-absolute top-50 start-50 translate-middle"
        >
            {{ 'fe_landing_about_us_image' | translate }}
        </h2>
    </section>
    <section class="about__us">
        <div class="about__us__content px-md-4 px-2 pb-4">
            <div class="about__us__content__container container-xl">
                <div
                    class="about__us__content__container__interesting row d-flex align-items-center"
                >
                    <h3
                        class="about__us__content__container__interesting__text col py-4"
                    >
                        {{ 'fe_landing_about_us_interesting' | translate }}
                    </h3>
                </div>
                <div class="about__us__content__container__extra row pt-4">
                    <div
                        class="about__us__content__container__extra__one col-12 col-md-6 col-lg-4 d-flex flex-column"
                    >
                        <div class="row">
                            <div class="col-0 col-md-2 d-none d-md-block">
                                <img
                                    [src]="'images/globe-red-light.svg' | cdn"
                                    alt="World icon"
                                />
                            </div>
                            <div class="col-12 col-md-10 d-flex flex-column">
                                <h4 class="mb-4">
                                    {{
                                        'fe_landing_about_us_interesting_one_title'
                                            | translate
                                    }}
                                </h4>
                                <p>
                                    {{
                                        'fe_landing_about_us_interesting_one_subtitle'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="about__us__content__container__extra__two col-12 col-md-6 col-lg-4 pt-4 pt-md-0 d-flex flex-row"
                    >
                        <div class="row">
                            <div class="col-0 col-md-2 d-none d-md-block">
                                <img
                                    [src]="'images/online-check-in.svg' | cdn"
                                    alt="Checkmark icon"
                                />
                            </div>
                            <div class="col-12 col-md-10 d-flex flex-column">
                                <h4 class="mb-4">
                                    {{
                                        'fe_landing_about_us_interesting_two_title'
                                            | translate
                                    }}
                                </h4>
                                <p>
                                    {{
                                        'fe_landing_about_us_interesting_two_subtitle'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="about__us__content__container__extra__three col-12 col-md-6 col-lg-4 pt-4 pt-md-0 d-flex flex-row"
                    >
                        <div class="row">
                            <div class="col-0 col-md-2 d-none d-md-block">
                                <img
                                    [src]="
                                        'images/spray-bottle-purple.svg' | cdn
                                    "
                                    alt="Spray bottle"
                                />
                            </div>
                            <div class="col-12 col-md-10 d-flex flex-column">
                                <h4 class="mb-4">
                                    {{
                                        'fe_landing_about_us_interesting_three_title'
                                            | translate
                                    }}
                                </h4>
                                <p>
                                    {{
                                        'fe_landing_about_us_interesting_three_subtitle'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="about__us__bottom">
        <div class="about__us__bottom__content px-lg-8 px-md-4 py-4">
            <div
                class="about__us__bottom__content__container container-xl px-4 mt-2"
            >
                <div class="row">
                    <div
                        class="col-md-2 col-lg-3 d-flex flex-column justify-content-center align-items-center align-items-md-start align-items-lg-center pb-4"
                    >
                        <img
                            [src]="
                                'images/illustration-circle-car-keys.svg' | cdn
                            "
                            alt="Car keys"
                        />
                    </div>
                    <div
                        class="col-md-5 col-lg-4 d-flex flex-column align-items-center align-items-md-start pb-4"
                    >
                        <p class="about__us__bottom__content__container__title">
                            {{
                                'fe_landing_about_us_two_second_title'
                                    | translate
                            }}
                        </p>
                        <h3
                            class="about__us__bottom__content__container__subtitle"
                        >
                            {{
                                'fe_landing_about_us_two_second_subtitle'
                                    | translate
                            }}
                        </h3>
                    </div>
                    <div
                        class="col-md-5 col-lg-4 d-flex flex-column align-items-center align-items-md-start pb-4"
                    >
                        <p class="about__us__bottom__content__container__title">
                            {{
                                'fe_landing_about_us_two_third_title'
                                    | translate
                            }}
                        </p>
                        <fe-button
                            [style]="'tertiary'"
                            [routerLink]="'/' | formatUrl"
                            [fragment]="'doReservation'"
                            >{{
                                'fe_landing_about_us_two_third_button'
                                    | translate
                            }}</fe-button
                        >
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
